import React from 'react';
import uf_slides from "../Static/UF_PTM_Workshop_SOUPS_-_August_2025.pdf"
import linddun_slides from "../Static/LINDDUN.pptx"
import keynote_slides from "../Static/Keynote-Privacy___Threat_Modeling.pdf"
import ajibuwa_slides from "../Static/Ajibuwa.pdf"
import ai_slides from "../Static/AI_PTM_SOUPS_2025_FINAL.pptx"
import bridge_slides from "../Static/Bridging_the_Gap_-_Meyers_Golliher.pdf"


export default function Proceedings(props) {

    return (
        <div className='base-page'>
            <h4 className='heading'>WPTM 2025</h4>
            <div class='paper'>
                <h6>Workshop Summary Coming Soon</h6>
            </div>
        
            <h4 className='heading new-section'>Privacy Threat Model Updates</h4>
            <div class='paper'>
                <h5>
                <a href={uf_slides} download="UF PTM Workshop SOUPS - August 2025.pdf">
                UsersFirst</a>
                </h5>
                <h6>Hana Habib, Norman Sadeh, and Lorrie Cranor, CMU</h6>
            </div>
            <div class='paper'>
                <h5>
                <a href={linddun_slides} download="LINDDUN.pptx">
                LINDDUN</a>
                </h5>
                <h6>Laurens Sion, LINDDUN</h6>
            </div>
            
            <h4 className='heading new-section'>Presentations</h4>
            <div class='paper'>
                <h5>Keynote</h5>
                <h5>
                <a href={keynote_slides} download="Keynote-Privacy & Threat Modeling.pdf">
                Privacy & Threat Modeling</a>
                </h5>
                <h6>Matthew Coles</h6>
            </div>
            <div class='paper'>
                <h5>Presentation 1</h5>
                <h5>
                <a href={ajibuwa_slides} download="Ajibuwa.pdf">
                Beyond Security: A Privacy-Centric Threat Model for Autonomous AI Agents</a>
                </h5>
                <h6>Opeyemi Ajibuwa</h6>
            </div>
            <div class='paper'>
                <h5>Presentation 2</h5>
                <h5>
                <a href={ai_slides} download="AI PTM_SOUPS_2025_FINAL.pptx">
                Privacy Threat Modeling for AI User Journeys</a>
                </h5>
                <h6>Srinivas Jantali, Sri Pravallika Maddipati</h6>
            </div>
            <div class='paper'>
                <h5>Presentation 3</h5>
                <h5>
                <a href={bridge_slides} download="Bridging the Gap - Meyers_Golliher.pdf">
                Bridging the Gap Applying Threat Intelligence Models to Digital Privacy Threats</a>
                </h5>
                <h6>Stephen Meyers, Geoffrey Golliher </h6>
            </div>
    </div>
    )
}